module.exports = __webpack_public_path__ + "img/crustaces.784c199c.svg";